import React, { useState }  from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "react-router-dom";
import T from "i18n";
import globalState from "globalState";
import Logo from "./atoms/Logo";

const Links = ["businessLines", "globalBrands"];
const Language = ["english", "german", "turkish", "italian", "french", "polish"];

const Wrapper = styled.div`  
   &.d-none {
    display: none;
   }`;

const TopLinksWrapper = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.palette.grey.ultraLight};

  @media screen and (max-width: 640px) {
    flex-flow: row wrap;
  }

  ${({ theme }) => theme.mediaQueries.medium} {
    padding: 0 ${({ theme }) => theme.spacer * 4}px;
  }
`;

const TopLinks = styled.ul`
  display: flex;
  ${({ theme }) => theme.resFontSize.small};

  li {
    margin-left: ${({ theme }) => theme.spacer * 2}px;
    margin-right: ${({ theme }) => theme.spacer * 2}px;
  }

  a {
    border: none;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.grey.dark};
    padding: ${({ theme }) => theme.spacer * 1}px 0;
  }

  ${({ theme }) => theme.mediaQueries.medium} {

    a {
      padding: ${({ theme }) => theme.spacer * 1.5}px 0;
    }
  }
@media print {
  display:block;    
    li{
        display:inline-block;
    }

  }
}
`;

const Languages = styled.div`
    position: relative;
    margin-left: auto;

    @media print {
        display: none;
    }

    @media screen and (max-width: 640px) {
        width: 100vw;
        background-color: ${({ theme }) => theme.palette.grey.light};
    }

    :hover {
        background-color: ${({ theme }) => theme.palette.grey.light};
    }

    &.toggle-open {
        .dropdown-menu {
            display: block !important;
        }
    }
`;

const DropdownToggle = styled.div`
    font-size: 13px;
    font-weight: bold;
    height: 100%;
    padding: 15px 20px;
    cursor: pointer;
    background-image:
        linear-gradient(45deg, transparent 50%, #000 50%),
        linear-gradient(135deg, #000 50%, transparent 50%);
    background-position:
        calc(100% - 10px) calc(50% - 3px),
        calc(100% - 6px) calc(50% - 3px);
    background-size:
        5px 5px,
        5px 5px;
    background-repeat: no-repeat;

    @media screen and (min-width: 640px) {
        padding: 15px 20px 15px 10px;
    }
`;

const DropdownMenu = styled.div`
    position: absolute;
    display: none;
    top: 100%;
    left: 0;
    z-index: 1000;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: ${({ theme }) => theme.palette.white};
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.15);
    border-radius: 0.25rem;

    @media screen and (max-width: 640px) {
        width: 100%;
    }

    .dropdown-item  {
        display: block;
        width: 100%;
        padding: 2rem 1.5rem;
        clear: both;
        font-weight: 400;
        text-align: inherit;
        white-space: nowrap;
        background-color: transparent;
        border: 0;
        color: inherit;

        @media screen and (min-width: 640px) {
            padding: 0.25rem 1.5rem;
        }

        &:hover {
            text-decoration: none;
            background-color: ${({ theme }) => theme.palette.grey.ultraLight};
        }
    }
`;

const LogoWrapper = styled.div`
  @media print {
    display:block;    
  }
  padding: ${({ theme }) => theme.spacer * 1.5}px;
  background-color: ${({ theme }) => theme.palette.white};
  border-bottom: 3px solid ${({ theme }) => theme.palette.primary};

  display: flex;
  align-items: stretch;

  a {
    @media print {
      display:inline-block;    
    }
    border: none;
  }
  .Logo {
    font-size: 1.6rem;
    @media print {
      font-size: 30px;
    }
  }

  > span {
    @media print {
      display:inline-block;    
      font-size: 20px;
      position:relative;
      span{
        position:absolute;
        top:5px;
        
      }
    }
    font-size: 1.3rem;
    display: flex;
    align-items: center;
    &:before {
      @media print {
        display:inline-block;    
        height:30px;        
      }
      content: "";
      display: block;
      margin: 0 ${({ theme }) => theme.spacer}px;
      width: 1px;
      height: 100%;
      background-color: ${({ theme }) => theme.palette.grey.medium};
    }
    color: ${({ theme }) => theme.palette.grey.medium};
  }

  ${({ theme }) => theme.mediaQueries.medium} {
    padding: ${({ theme }) => theme.spacer * 2.5}px
      ${({ theme }) => theme.spacer * 4}px;
    .Logo {
      font-size: 2.8rem;
    }
    span {
      font-size: 1.9rem;
    }
  }


`;


const Header = ({ className, heading }) => {
    const classes = ["Header"];

    // Toggle language selector dropdown toggle class //
    const [isActive, setActive] = useState("false");
    const toggleClass = () => {
        setActive(!isActive);
    };

    // Remove dropdown menu when anywhere but dropdown is clicked //
    document.addEventListener("click", (event) => {
        if (!event.target.classList.contains("dropdown-toggle")) {
            setActive(true);
        }
    });

    if (className) classes.push(className);
    const state = globalState();
    const LinksComponent = Links.map((link) => (
      <li key={link}>
        <a href={T({ path: `header.${link}.link` })} target="_blank" rel="noreferrer">
          {T({ path: `header.${link}.text` })}
        </a>
      </li>
    ));
    const LanguageSelector = Language.map((link) => (
      <a className="dropdown-item" href={T({ path: `languages.${link}.link` })}>
        {T({ path: `languages.${link}.text` })}
      </a>
    ));

    return (
        !state.iframe.get() && (
        <Wrapper className={classes.join(" ")}>
          <TopLinksWrapper className="top-links-wrapper">
            <TopLinks>{LinksComponent}</TopLinks>
            <Languages className={!isActive ? "language-selector toggle-open" : "language-selector"}>
              <DropdownToggle className="dropdown-toggle" onClick={toggleClass}><T path="languages.active.text" /></DropdownToggle>
              <DropdownMenu className="dropdown-menu">
                {LanguageSelector}
              </DropdownMenu>
            </Languages>
          </TopLinksWrapper>
          <LogoWrapper>
            <Link to="/">
              <Logo />
            </Link>
            {heading && <span><span>{heading}</span></span>}
          </LogoWrapper>
        </Wrapper>
      )
    );
};

Header.displayName = "Header";

Header.propTypes = {
    className: PropTypes.string,
    heading: PropTypes.string,
};

Header.defaultProps = {
    className: null,
    heading: null,
};

export default Header;
